import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import NumberFormat from "react-number-format";
import DanhSachQuyKhacApi from "service/DanhSachQuyKhacApi";
import { formatDayMonth } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import { getUserLogin } from "utils/user";
import GoiPhanMemApi from "service/goiPhanMemApi";
import CauHinhApi from "service/cauHinhApi";
import { convertDate } from "utils/formatDate";

const ModalChuyenNhapRutQuy = ({
  show,
  onHide,
  onSuccess,
  mode,
  RoleQuyTienMatDuyetQuy,
}) => {
  const [Value, setValue] = useState("");
  const [date, setDate] = useState(new Date());
  const [Note, setNote] = useState("");
  const [User, setUser] = useState("");
  const [saving, setSaving] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const ValueInputRef = useRef(null);

  useEffect(() => {
    if (show) {
      console.log("dateTime", 1);
      if (isLoaded) {
        CauHinhApi.getTimeServer().then((response) => {
          if (response.status === 200) {
            let dateTime = convertDate(response.data.result);
            console.log("dateTime", dateTime);
            setDate(dateTime);
          } else {
            setDate(new Date());
          }
          setIsLoaded(false);
        });
      }
      setValue("");
      setNote("");
      const currentUser = getUserLogin();
      setUser(currentUser?.UserName || "");
      setSaving(false);
    }
  }, [show, mode]);

  let configUI = { title: "" };
  switch (mode?.type) {
    case 50:
      configUI = { title: "Chuyển quỹ" };
      break;
    case 51:
      configUI = { title: "Nhập quỹ" };
      break;
    case 52:
      configUI = { title: "Rút quỹ" };
      break;
    default:
      break;
  }

  const handleSave = () => {
    const numericValue = Number(Value.toString().replace(/,/g, ""));
    if (!numericValue || numericValue <= 0) {
      pushNotification("Vui lòng nhập số tiền hợp lệ.", "error");
      if (ValueInputRef.current) ValueInputRef.current.focus();
      return;
    }
    setSaving(true);
    GoiPhanMemApi.GoiPhanMemHienTai()
      .then((resGoi) => {
        let adminApprove = 0;
        let status = -1;
        const goiId = resGoi?.data?.GoiId || resGoi?.data;
        if (goiId === 10) {
          adminApprove = 1;
          status = 1;
        } else if (RoleQuyTienMatDuyetQuy) {
          adminApprove = 1;
          status = 1;
        } else {
          adminApprove = 0;
          status = -1;
        }
        const payload = {
          ThuChiId: 0,
          Type: mode.type,
          Name: configUI.title,
          Time: formatDayMonth(date),
          Value: numericValue,
          Note: Note,
          UserName: User,
          AdminApprove: adminApprove,
          Status: status,
        };
        DanhSachQuyKhacApi.addorupdate(payload)
          .then((res) => {
            if (res.status === 200) {
              if (RoleQuyTienMatDuyetQuy) {
                pushNotification(`${configUI.title} thành công!`, "success");
              } else {
                pushNotification(
                  `${configUI.title} thành công. Vui lòng chờ duyệt!`,
                  "success"
                );
              }

              onSuccess();
              onHide();
            } else {
              pushNotification("Có lỗi xảy ra khi lưu.", "error");
            }
          })
          .catch((errSave) => {
            console.error("Lỗi khi lưu:", errSave);
            pushNotification("Lỗi khi lưu dữ liệu.", "error");
          })
          .finally(() => {
            setSaving(false);
          });
      })
      .catch((errGoi) => {
        console.error("Lỗi lấy gói:", errGoi);
        setSaving(false);
        pushNotification("Không lấy được thông tin gói phần mềm.", "error");
      });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modal-new modal-fade"
    >
      <div className="modal-content">
        <div className={`modal-header`}>
          <h4 className="modal-title ">
            <span className="btn-icon-right">
              <i className="fas fa-money-check-alt"></i>
            </span>{" "}
            {configUI.title}
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={onHide}
            style={{ opacity: 1 }}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </div>

        <div
          className="modal-body"
          style={{ overflowY: "visible", padding: "20px" }}
        >
          <div className="form-group">
            <label className="font-color-default font-bold">
              Ngày giao dịch
            </label>
            <DateTimePicker
              value={date}
              onChange={setDate}
              className="form-control input-sm"
            />
          </div>
          <div className="form-group">
            <label className="font-color-default font-bold">
              Người giao dịch
            </label>
            <input
              type="text"
              className="form-control input-sm"
              value={User}
              disabled
            />
          </div>
          <div className="form-group">
            <label className="font-color-default font-bold">
              Số tiền <span className="text-danger">*</span>
            </label>
            <NumberFormat
              className="form-control input-sm"
              placeholder="Nhập số tiền"
              value={Value}
              thousandSeparator={true}
              onValueChange={(v) => setValue(v.value)}
              getInputRef={ValueInputRef}
              allowNegative={false}
            />
          </div>

          <div className="form-group">
            <label className="font-color-default font-bold">Ghi chú</label>
            <textarea
              className="form-control1 input-sm"
              rows="3"
              value={Note}
              onChange={(e) => setNote(e.target.value)}
              style={{ width: "100%", minHeight: "80px" }}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
            disabled={saving}
          >
            <i className="mdi mdi-close"></i>&nbsp; Đóng
          </button>
          <button
            className={`btn `}
            onClick={handleSave}
            disabled={saving}
            style={{
              background: "#056569",
              color: "white",
              height: 38,
              fontSize: "15px",
              textTransform: "none",
            }}
          >
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm"></span>&nbsp;
                Đang lưu...
              </>
            ) : (
              <>
                <i className="mdi mdi-content-save"></i>&nbsp; Xác nhận
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalChuyenNhapRutQuy;
